export var props = {
  type: {
    type: String,
    required: true,
    validator(val) {
      return ['lubo', 'baofang'].includes(val);
    }
  }
};